/** Convenience method for unwrapping data under a "platform" key (as per gatsby-source-graphql config convention) */
export var platformData = function (result) {
  var platform = result.platform;
  return platform;
};